import { toast } from "sonner";

import { Button } from "@photo-booth/ui/button";
import { useDeviceId } from "@/hooks/useDeviceId";

export function DeviceInfoSection() {
  const deviceId = useDeviceId();

  if (!deviceId) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(deviceId);
      toast.success("Device ID copied");
    } catch {
      toast.error("Couldn't copy — long-press to copy manually");
    }
  };

  return (
    <section className="mt-12">
      <h2>Support</h2>
      <p className="font-family-reenie mt-4">Device ID</p>
      <div className="mt-2 flex items-center gap-3">
        <code
          className="font-mono flex-1 min-w-0 truncate"
          title={deviceId}
        >
          {deviceId}
        </code>
        <Button type="button" size="sm" variant="outline" onClick={handleCopy}>
          Copy
        </Button>
      </div>
    </section>
  );
}
